import React, { ChangeEvent } from 'react';
import styles from './TextInput.module.scss';

interface TextInputProps {
  /**
   * Input label
   */
  label: string;
  
  /**
   * Input value
   */
  value: string;
  
  /**
   * Callback for input change
   */
  onChange: (value: string) => void;
  
  /**
   * Input placeholder
   */
  placeholder?: string;
  
  /**
   * Optional error message
   */
  error?: string;
  
  /**
   * Input type (default: 'text')
   */
  type?: 'text' | 'email' | 'password' | 'number';
  
  /**
   * Whether the input is required
   */
  required?: boolean;
  
  /**
   * Whether the input is disabled
   */
  disabled?: boolean;
  
  /**
   * Optional help text
   */
  helpText?: string;
  
  /**
   * Additional CSS class
   */
  className?: string;
}

const TextInput: React.FC<TextInputProps> = ({
  label,
  value,
  onChange,
  placeholder = '',
  error,
  type = 'text',
  required = false,
  disabled = false,
  helpText,
  className = ''
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const handleBlur = (e: ChangeEvent<HTMLInputElement>) => {
    if (type !== 'password') {
      const trimmed = e.target.value.trim();
      if (trimmed !== e.target.value) {
        onChange(trimmed);
      }
    }
  };
  
  return (
    <div className={`${styles.inputContainer} ${className}`}>
       {label &&<div className={styles.labelContainer}>
        <label className={styles.label}>
          {label}
          {/* {required && <span className={styles.required}>*</span>} */}
        </label> 
      </div>}
      <div className={styles.innerContainer}>
      <input
        type={type}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        className={`${styles.input} ${error ? styles.errorInput : ''}`}
      />
      
      {helpText && !error && <div className={styles.helpText}>{helpText}</div>}
      {error && <div className={styles.errorText}>{error}</div>}
      </div>
    </div>
  );
};

export default TextInput;